import {
  IonAvatar,
  IonButton,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonRow,
} from "@ionic/react";
import * as d3 from "d3";
import { arrowForward, checkmarkCircleOutline, close } from "ionicons/icons";
import ZoomSvg from "../../assets/svg/zoom.svg";
import TractorLeftSvg from "../../assets/svg/tractorLeft.svg";
import TractorRightSvg from "../../assets/svg/tractorRight.svg";
import TractorFrontSvg from "../../assets/svg/tractorFront.svg";
import { ReactSVG } from "react-svg";

import "./ReportDamageModal.css";

import { tractorMapping } from "../../data/vehicleMapping";
import { inspectionRouteMapping } from "../../data/InspectionRoute";
import { useGetCurrentJourneyQuery } from "../../api/journey";
interface Step5Props {
  setStep: (step: number) => void;
  setSelectedElement: (element: string) => void;
  setSelectType: (element: string) => void;
  setSelectSide: (element: string) => void;
  selectedElement: string;
  selectSide: string;
  selectType: string;
}

const Step5: React.FC<Step5Props> = ({
  setStep,
  selectedElement,
  setSelectedElement,
  setSelectType,
  setSelectSide,
  selectSide,
  selectType,
}) => {
  const { data: currentJourney } = useGetCurrentJourneyQuery();

  return (
    <div>
      <IonRow className="ReportDamageModal-title">
        Sélectionnez le côté du véhicule concerné par le dommage
      </IonRow>
      {currentJourney?.mainVehicle.type.code === "Tractor" ? (
        <>
          <IonRow className="ReportDamageModal-subtitle">Tracteur</IonRow>
          <IonRow className="ReportDamageModal-cards-nowrap">
            {Object.values(inspectionRouteMapping()["Tractor"]).map((el) => (
              <div
                className="ReportDamageModal-cards"
                onClick={() => {
                  setSelectSide(el.side);
                  setSelectType(el.type);
                }}
              >
                <div
                  className={`ReportDamageModal-tractorButton ${
                    el.side === selectSide && el.type === selectType
                      ? "ReportDamageModal-tractorButton_active"
                      : ""
                  }`}
                >
                  <IonIcon
                    src={el.svgres}
                    className={`ReportDamageModal-tractorButton-icon ${
                      el.side === selectSide && el.type === selectType
                        ? "ReportDamageModal-tractorButton-icon_active"
                        : ""
                    }`}
                  />
                </div>
                {el.name}
              </div>
            ))}
          </IonRow>
        </>
      ) : null}
      {currentJourney?.trailer?.id ? (
        <>
          <IonRow className="ReportDamageModal-subtitle">Semi-remorque</IonRow>
          <IonRow className="ReportDamageModal-cards-nowrap">
            {Object.values(inspectionRouteMapping()["Trailer"]).map((el) => (
              <div
                className="ReportDamageModal-cards"
                onClick={() => {
                  setSelectSide(el.side);
                  setSelectType(el.type);
                }}
              >
                <div
                  className={`ReportDamageModal-tractorButton ${
                    el.side === selectSide && el.type === selectType
                      ? "ReportDamageModal-tractorButton_active"
                      : ""
                  }`}
                >
                  <IonIcon
                    src={el.svgres}
                    className={`ReportDamageModal-tractorButton-icon ${
                      el.side === selectSide && el.type === selectType
                        ? "ReportDamageModal-tractorButton-icon_active"
                        : ""
                    }`}
                  />
                </div>
                {el.name}
              </div>
            ))}
          </IonRow>
        </>
      ) : null}
      {currentJourney?.mainVehicle.type.code === "Carrier" ? (
        <>
          <IonRow className="ReportDamageModal-subtitle">Porteur</IonRow>
          <IonRow className="ReportDamageModal-cards-nowrap">
            {Object.values(inspectionRouteMapping()["Carrier"]).map((el) => (
              <div
                className="ReportDamageModal-cards"
                onClick={() => {
                  setSelectSide(el.side);
                  setSelectType(el.type);
                }}
              >
                <div
                  className={`ReportDamageModal-tractorButton ${
                    el.side === selectSide && el.type === selectType
                      ? "ReportDamageModal-tractorButton_active"
                      : ""
                  }`}
                >
                  <IonIcon
                    src={el.svgres}
                    className={`ReportDamageModal-tractorButton-icon ${
                      el.side === selectSide && el.type === selectType
                        ? "ReportDamageModal-tractorButton-icon_active"
                        : ""
                    }`}
                  />
                </div>
                {el.name}
              </div>
            ))}
          </IonRow>
        </>
      ) : null}
      <div className="ReportDamageModal-footer">
        {selectSide && selectType ? (
          <IonButton
            color={"success"}
            expand="block"
            onClick={() =>
              setStep(
                selectSide === "Inside" || selectSide === "TrailerInside"
                  ? 1
                  : 0
              )
            }
          >
            Continuer
            <IonIcon icon={arrowForward} slot="end" />
          </IonButton>
        ) : null}
      </div>
    </div>
  );
};

export default Step5;
